import { Injectable } from "@angular/core";
import { Actions, Effect, ofType } from "@ngrx/effects";
import { Action } from "@ngrx/store";
import { Observable, of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";
import { AdministratorModeActions } from "../../_store";
import { AdministratorModeActionTypes } from "../actions/administrator-mode.actions";
import { MenuService } from 'src/app/header-menu/services/menu.service';
import { RoutingStateService } from '../../services/routing-state/routing-state.service';

@Injectable()
export class AdministratorModeEffects {

    @Effect()
    loadMenuAdmin$: Observable<Action> = this.actions$.pipe(
        ofType<AdministratorModeActions.LoadMenuAdmin>(AdministratorModeActionTypes.LOAD_MENU_ADMIN))
        .pipe(
            map((action: AdministratorModeActions.LoadMenuAdmin) => 'global'),
            switchMap(() => this.menuService.getMenuAdmin().pipe(
                map((response: any) => {
                    if (response && response.data) {
                        const sortedMenu = this.sortMenu(response.data);
                        for (let i = 0; i < sortedMenu.length; i++) {
                            sortedMenu.items = this.sortMenu(sortedMenu[i].items);
                        }
                        sessionStorage.setItem("menu", JSON.stringify(sortedMenu));
                        localStorage.setItem("isAdmin", "true");
                        return new AdministratorModeActions.LoadMenuAdminSuccess(sortedMenu);
                    }
                    else {
                        return new AdministratorModeActions.LoadMenuAdminFailure();
                    }
                }),
                catchError(() => of(new AdministratorModeActions.LoadMenuAdminFailure()))
            )
        )
    )

    @Effect()
    loadMenuRegular$: Observable<Action> = this.actions$.pipe(
        ofType<AdministratorModeActions.LoadMenuRegular>(AdministratorModeActionTypes.LOAD_MENU_REGULAR))
        .pipe(
            map((action: AdministratorModeActions.LoadMenuRegular) => 'global'),
            switchMap(() => this.menuService.getMenuRegular().pipe(
                map((response: any) => {
                    if (response && response.data) {
                        const sortedMenu = this.sortMenu(response.data);
                        for (let i = 0; i < sortedMenu.length; i++) {
                            sortedMenu.items = this.sortMenu(sortedMenu[i].items);
                        }
                        sessionStorage.setItem("menu", JSON.stringify(sortedMenu));
                        if (localStorage.getItem("isAdmin")) {
                            localStorage.removeItem("isAdmin");
                            this.routingStateService.clearUnauthorizedTabs();
                        }
                        return new AdministratorModeActions.LoadMenuRegularSuccess(sortedMenu);
                    }
                    else {
                        return new AdministratorModeActions.LoadMenuRegularFailure();
                    }
                }),
                catchError(() => of(new AdministratorModeActions.LoadMenuRegularFailure()))
            )
        )
    )

    sortMenu(menu: any) {
        if (menu) {
            menu.sort(function (a: any, b: any) {
                if (a.order < b.order) {
                    return -1;
                }
                if (a.order > b.order) {
                    return 1;
                }
                return 0;
            });
        }
        return menu;
    }

    constructor(
        private actions$: Actions,
        private menuService: MenuService,
        private routingStateService: RoutingStateService
    ) { }
}
